import { render, staticRenderFns } from "./AMCPopUp.vue?vue&type=template&id=1cfc68a3"
import script from "./AMCPopUp.vue?vue&type=script&lang=js"
export * from "./AMCPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports